export default [
    {
        name: "context",
        path: "/contexthelp",
        component: () => import(/* webpackChunkName: "help" */ "@/views/help/FAQContent.vue"),
        meta: {
            public: true,
        },
    },
]
